/**
 * When rounding to 0 decimals with Sub-1% Style set to "<1%", slices under 1%
 * of the total are hidden from the pie rather than shown as "0%". Shared so
 * every place that lists "the slices actually rendered" (legend, color
 * picker) stays in sync with what the chart itself draws.
 */
export function filterSubOnePercentSlices<T extends { y: number }>(
  slices: T[],
  percentageFormatting: number | undefined,
  subOnePercentStyle: "<1%" | "0%" | undefined,
): T[] {
  if (percentageFormatting !== 0 || subOnePercentStyle !== "<1%") {
    return slices;
  }
  const total = slices.reduce((sum, slice) => sum + slice.y, 0);
  return slices.filter((slice) => {
    const percentage = total > 0 ? (slice.y / total) * 100 : 0;
    return percentage >= 1;
  });
}
